import {ApplicationConfig, isDevMode, LOCALE_ID} from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {TranslocoHttpLoader} from './transloco-loader';
import {provideTransloco} from '@jsverse/transloco';
import {provideStore} from '@ngrx/store';
import {provideStoreDevtools} from '@ngrx/store-devtools';
import {provideEffects} from '@ngrx/effects';
import {loggerInterceptor} from './shared/interceptors/logger/interceptor-logger.interceptor';
import {errorInterceptor} from './shared/interceptors/error/interceptor-error.interceptor';
import {metaReducers, rehydrateState} from './store/meta-reducers';
import {AuthEffects} from './store/auth/auth.effect';
import {reducers} from './store/reducers';
import {provideAnimations} from '@angular/platform-browser/animations';
import {ConfirmationService, MessageService} from 'primeng/api';
import {LayoutEffects} from './store/layout/layout.effects';

import {initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {environment} from '../environments/environment';

import {getAuth, provideAuth} from '@angular/fire/auth';

import localeIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localeIt);

export const appConfig: ApplicationConfig = {
    providers: [
      { provide: LOCALE_ID, useValue: 'it' },
      ConfirmationService, MessageService,
        provideRouter(routes),
        provideAnimations(),
        provideHttpClient(withInterceptors([
            loggerInterceptor,
            errorInterceptor
        ])),
        provideTransloco({
            config: {
                availableLangs: ['en', 'it'],
                defaultLang: 'it',
                prodMode: !isDevMode(),
            },
            loader: TranslocoHttpLoader
        }),
        provideStore(
            reducers,
            { metaReducers: metaReducers, initialState: rehydrateState() }
        ),
        provideEffects([AuthEffects, LayoutEffects]),
        provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),



        provideFirebaseApp(() => initializeApp(environment.firebase)), // Inicializa Firebase
        provideAuth(() => getAuth())

    ],

};

